<app-preloader *ngIf="isLoading"></app-preloader>
<app-notifications></app-notifications>
<!-- <button (click)="status()">Estatus</button> -->
<form action="" [formGroup]="formInsurance">
  <div class="edition">
    <!-- Nombre y RoRAC -->
    <div class="nameAndRoRAC">
      <!-- Si se está editando un seguro incluir la clase "insurance" en el div.name -->
      <div class="inputWrapper name insurance">
        <label for="">Nombre <span class="required">*</span></label>
        <input name="dealName" id="dealName" formControlName="dealName" />
      </div>
    </div>

    <!-- Información contractual -->
    <div class="contractMobileEdition" id="contract-edition">
      <div class="titleWrapper">
        <h4>Información contractual</h4>
        <a class="accordionControl" (click)="collapse()" style="cursor: pointer"></a>
      </div>
      <div class="accordionWrapper">
        <div>
          <div class="mainWrapper">
            <!-- Parámetros -->
            <div class="parameters">
              <!-- IVA -->
              <div class="row iva">
                <label>IVA <span class="required">*</span></label>
                <div class="wrapperS2">
                  <input
                    type="number"
                    formControlName="tax"
                    class="size1 textAlignRight gapRight"
                    (blur)="calculateUnitPriceWithTax(formInsurance, 'unitPriceWithTax')"
                    (keypress)="preventInvalidCharacters($event)"
                  />
                  <span>%</span>
                </div>
              </div>
              <div class="row exento">
                <label>Exento IVA</label>
                <div>
                  @if (noVatExemptVisible) {
                    <span>NO</span>
                  } @else {
                    <div class="selectWrapper">
                      <div class="customSelect">
                        <select formControlName="taxFree" (ngModelChange)="calculateFinacialAmount(formInsurance)">
                          <option [value]="true">SI</option>
                          <option [value]="false">NO</option>
                        </select>
                      </div>
                    </div>
                  }
                </div>
              </div>

              <!-- Plazo -->
              <div class="row plazo">
                <label>Plazo <span class="required">*</span></label>
                <div class="wrapperS4">
                  <input
                    type="number"
                    formControlName="term"
                    class="size1 textAlignRight gapRight"
                    [max]="termMax"
                    (blur)="onChange()"
                    (keypress)="preventInvalidCharacters($event)"
                  />
                  <span>Meses (máx. {{ termMax }})</span>
                </div>
              </div>

              <!-- Caracteristicas -->
              <div class="row group">
                <div class="innerRow">
                  <label>Caracteristicas</label>
                </div>
                <div class="innerRow">
                  <textarea cols="30" rows="10" formControlName="feature"></textarea>
                </div>
              </div>

              <!-- Precio unitario -->
              <div class="row group">
                <label>Precio unitario <span class="required">*</span></label>
                <div class="innerRow">
                  <label>Sin IVA</label>
                  <div class="flexEnd">
                    <input
                      type="number"
                      id="unitPriceWithoutTax"
                      class="amount"
                      style="display: none"
                      formControlName="unitPriceWithoutTax"
                      (blur)="calculateUnitPriceWithoutTax(formInsurance, 'unitPriceWithoutTax')"
                      (keypress)="preventInvalidCharacters($event)"
                    />
                    <input
                      type="text"
                      id="hidden-unitPriceWithoutTax"
                      class="amount gapRight"
                      (focus)="showAmountInput('unitPriceWithoutTax')"
                      style="display: block"
                      [value]="formInsurance.controls['unitPriceWithoutTax'].value | currency : '' : ''"
                    />
                    <span>{{ currencySelected(formInsurance) }}</span>
                  </div>
                </div>
                <div class="innerRow">
                  <label>Con IVA</label>
                  <div class="flexEnd">
                    <input
                      type="number"
                      id="unitPriceWithTax"
                      class="amount"
                      style="display: none"
                      formControlName="unitPriceWithTax"
                      (blur)="calculateUnitPriceWithTax(formInsurance, 'unitPriceWithTax')"
                      (keypress)="preventInvalidCharacters($event)"
                    />
                    <input
                      type="text"
                      id="hidden-unitPriceWithTax"
                      class="amount gapRight"
                      (focus)="showAmountInput('unitPriceWithTax')"
                      style="display: block"
                      [value]="formInsurance.controls['unitPriceWithTax'].value | currency : '' : ''"
                    />
                    <span>{{ currencySelected(formInsurance) }}</span>
                  </div>
                </div>
              </div>

              <!-- Total venta -->
              <div class="row group">
                <label>Total venta</label>
                <div class="innerRow">
                  <label>Sin IVA</label>
                  <div class="flexEnd">
                    <span class="amountReadOnly gapRight">{{
                      formInsurance.controls['totalPriceWithoutTax'].value
                        ? (formInsurance.controls['totalPriceWithoutTax'].value | currency : '' : '')
                        : ''
                    }}</span>
                    <span>{{ currencySelected(formInsurance) }}</span>
                  </div>
                </div>
                <div class="innerRow">
                  <label>Con IVA</label>
                  <div class="flexEnd">
                    <span class="amountReadOnly gapRight">{{
                      formInsurance.controls['totalPriceWithTax'].value
                        ? (formInsurance.controls['totalPriceWithTax'].value | currency : '' : '')
                        : ''
                    }}</span>
                    <span>{{ currencySelected(formInsurance) }}</span>
                  </div>
                </div>
              </div>

              <!-- Monto a financiar -->
              <div class="row monto">
                <label>Monto a financiar</label>
                <div class="wrapperSX flexEnd">
                  <span class="amountReadOnly gapRight">{{
                    formInsurance.controls['financialAmount'].value
                      ? (formInsurance.controls['financialAmount'].value | currency : '' : '')
                      : ''
                  }}</span>
                  <span>{{ currencySelected(formInsurance) }}</span>
                </div>
              </div>

              <!-- Comisión por apertura -->
              <!-- <div>
            <div class="wrapperS1">
              <label>Comisión por apertura</label>
            </div>
            <div class="wrapperSX">
              <div class="innerWrapper">
                <div class="selectWrapper size2 gapRight">
                  <div class="customSelect">
                    <select
                      formControlName="openingFeeType"
                      (ngModelChange)="
                        calculateCommissionForOpening(
                          formInsurance,
                          'openingFee'
                        )
                      "
                    >
                      <option [value]="taxType.invoiceWithTax">
                        % Valor con IVA
                      </option>
                      <option [value]="taxType.invoiceWithoutTax">
                        % Valor sin IVA
                      </option>
                      <option [value]="taxType.amountToFinance">
                        % Monto financiar
                      </option>
                      <option [value]="taxType.fixedAmount">Monto fijo</option>
                    </select>
                  </div>
                </div>
                <input
                  type="number"
                  formControlName="openingFeePercentage"
                  (blur)="
                    calculateCommissionForOpening(formInsurance, 'openingFee')
                  "
                  [ngClass]="{
                    'input-deshabilitado':
                      formInsurance.controls['openingFeeType'].value ==
                      'monto_fijo'
                  }"
                  class="size0 textAlignRight gapRight"
                />
                <span>%</span>
              </div>
              <div class="innerWrapper">
                <input
                  type="text"
                  id="openingFee"
                  class="amount gapRight"
                  style="display: none"
                  (blur)="
                    calculateCommissionForOpening(formInsurance, 'openingFee')
                  "
                  formControlName="openingFee"
                  [ngClass]="{
                    'input-deshabilitado':
                      formInsurance.controls['openingFeeType'].value !=
                      taxType.fixedAmount
                  }"
                />
                <input
                  type="text"
                  id="hidden-openingFee"
                  class="amount gapRight"
                  (focus)="showAmountInput('openingFee')"
                  style="display: block"
                  [value]="
                    formInsurance.controls['openingFee'].value
                      | currency : '' : ''
                  "
                />
                <span>{{ currencySelected(formInsurance) }}</span>
              </div>
            </div>
          </div> -->
            </div>

            <!-- Calculation results -->
            <!-- <app-calculate-diro
              [profitDeal]="formInsurance.controls['profitDeal'].value"
              (updateDataDiro)="assignProfitDeal($event)"
            >
            </app-calculate-diro> -->
          </div>
          <div class="actionWrapper">
            <button (click)="calculateQuote()" [disabled]="!formInsurance.valid" class="secondary">Calcular</button>
            <button
              (click)="downloadJsonProcotiza()"
              *ngIf="activarBotonJson"
              [disabled]="!formInsurance.valid"
              class="secondary"
            >
              Descargar JSON
            </button>
          </div>
        </div>
      </div>
    </div>
    <!-- <app-quote [quote]="formInsurance.controls['result'].value" [quantity]="formInsurance.controls['quantity'].value"></app-quote> -->
    <!-- <app-special-payments (calculate)="calculateQuote()" [specialPaymentsUpdate]="formInsurance.controls['specialPayments'].value" (specialPayments)="assignSpecialPayments($event)" [idProposal]="formInsurance.controls['id'].value" [idQuote]="idQuote" [isValid]="!formInsurance.valid"></app-special-payments> -->
    <app-payments-mobile
      [quoteType]="quoteType"
      [payments]="formInsurance.controls['payments'].value"
      [quantity]="formInsurance.controls['quantity'].value"
      [currency]="currency"
      [readOnly]="true"
    >
    </app-payments-mobile>
  </div>
</form>

<div class="quotationActions">
  <button class="secondary" (click)="cancel()">Cancelar</button>
  <button class="primary" (click)="save()" [disabled]="!formInsurance.valid">Guardar</button>
</div>

<ng-template #modalTemplate>
  <div class="modal" style="max-width: 620px">
    <a class="close" (click)="closeModal()">Cerrar</a>
    <h1>Valor de seguro</h1>
    <p>El valor del seguro ingresado es mayor al valor de la unidad.</p>
    <div class="modalActions index">
      <button (click)="closeModal()" class="secondary">Cerrar</button>
      <!-- <button (click)="deleteAllSpecialPayments()" class="primary">Eliminar</button> -->
    </div>
  </div>
</ng-template>
